import { EnterSIMIDDetailsAction } from '../actions/EnterSIMIDDetailsAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
    requestBody: {
        sectionId: "EnterSIMIDDetails",
        steps: [
            {
                sequence: "0",
                stepId: "EnterSimIdDetails",
                offerContainerId: "",
                fields: [
                    {
                        name: "SIM Serial Number",
                        value: ""
                    },
                    {
                        name: "SIM PUK1 Number",
                        value: ""
                    },
                    {
                        name: "Status Code",
                        value: ""
                    },
                    {
                        name: "Status Message",
                        value: ""
                    },
                    {
                        name: "Message",
                        value: ""
                    },
                    {
                        name: "IMSI",
                        value: ""
                    },
                    {
                        name: "Reseller CRID",
                        value: ""
                    },
                    {
                        name: "Reseller MSISDN",
                        value: ""
                    },
                    {
                        name: "Dealer Id",
                        value: ""
                    },
                    {
                        name: "Dealer Name",
                        value: ""
                    },
                    {
                        name: "Promo Code",
                        value: ""
                    },
                    {
                        name: "NewStack",
                        value: "N"
                    }
                ]
            }
        ]
    },
    validateSimResponse : {

    }
}

const EnterSIMIDDetailsReducer = (state: any = initState, action: any) => {
    const { type } = action;
    const { payload } = action;
    var SimIdDetails = { ...state.requestBody.steps };

    switch (type) {
        case EnterSIMIDDetailsAction.SAVE_SIMID_DETAILS:
            SimIdDetails[0].fields[0].value = payload.simNumber;
            SimIdDetails[0].fields[1].value = payload.puk1Number;
            SimIdDetails[0].fields[2].value = payload.validateSimResponse.StatusCode;
            SimIdDetails[0].fields[3].value = payload.validateSimResponse.StatusMessage;
            SimIdDetails[0].fields[4].value = payload.validateSimResponse.Message;
            SimIdDetails[0].fields[5].value = payload.validateSimResponse.IMSI;
            SimIdDetails[0].fields[6].value = payload.validateSimResponse.ResellerCRID;
            SimIdDetails[0].fields[7].value = payload.validateSimResponse.ResellerMSISDN;
            SimIdDetails[0].fields[8].value = payload.validateSimResponse.DealerId;
            SimIdDetails[0].fields[9].value = payload.validateSimResponse.DealerName;
            SimIdDetails[0].fields[10].value = payload.validateSimResponse.PromoCode;
            SimIdDetails[0].fields[11].value = payload?.validateSimResponse?.NewStack ? payload?.validateSimResponse?.NewStack : "N";
            SimIdDetails[0].offerContainerId = payload.offerContainerId;
            return state;

        case EnterSIMIDDetailsAction.VALIDATE_SIM_SUCCESS:
            return { ...state, validateSimResponse: payload };

        case EnterSIMIDDetailsAction.VALIDATE_SIM_FAILURE:
            return { ...state, validateSimResponse: payload };

        case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
            let section = payload.sections.filter((section: any) => {
                return (section.sectionId === 'EnterSIMIDDetails')
            });
            if (section.length > 0) {
                SimIdDetails[0].offerContainerId = section[0].steps[0].offerContainerId;
                for (let i = 0; i < SimIdDetails[0].fields.length; i++) {
                    const SimIdDetailsField = section[0].steps[0].fields.filter((field: any) => { return (field.name === SimIdDetails[0].fields[i].name) })[0];
                    SimIdDetails[0].fields[i].value = SimIdDetailsField ? SimIdDetailsField.value : "";
                }
            }
            return state;

        default:
            return state;
    }
}

export default EnterSIMIDDetailsReducer;